/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
/**
 *
 * @param {Object} param0
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const PortraitComponent = ({ item, backgroundStyle }) => {
  const textColorBase = backgroundStyle === 'amber' ? 'black' : '#F1EDE9';
  return (
    <Box
      height={{ lg: '555.69px', '2xl': '705px', md: '670px', base: 'auto' }}
      width="100%"
      maxW={{ lg: '370.46px', '2xl': '468px' }}
      position="relative"
      _hover={{ '.textBox': { display: 'block' } }}
    >
      <LazyLoadImageComponent
        src={item.image.url}
        alt={item.image.alt}
        height={{ md: '100%', base: 'auto' }}
        width="100%"
        objectFit="cover"
      />
      {item.image.alt && (
        <Box
          className="textBox"
          // border="2px solid green"
          p={{ md: '0.5rem', base: '0.5rem 1rem' }}
          position={{ md: 'absolute', base: 'relative' }}
          bottom={{ md: '0', base: 'auto' }}
          width="100%"
          fontWeight={400}
          fontSize={{ md: '1rem', base: '0.875rem' }}
          fontFamily="var(--FedraSansStd-book)"
          letterSpacing="2%"
          lineHeight={{ md: '1.6rem', base: '1.4rem' }}
          bg={{ md: '#010509CC', base: 'transparent' }}
          display={{ base: 'block', md: 'none' }}
        >
          <Text
            color={{ base: textColorBase, md: '#F1EDE9' }}
            fontWeight={400}
            fontFamily="var(--FedraSansStd-book)"
            fontSize={{ base: '.875rem' }}
            lineHeight={{ base: '1.4rem' }}
            letterSpacing={'0.32px'}
          >
            {item.image.alt}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PortraitComponent;
